import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmProductUnit } from "@natiwi/shared/models/product-unit.model";

export class NatProductUnitRepository extends NatCatalogRepository<OrmProductUnit> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/productUnits';
        let repoModel: Type<OrmProductUnit> = OrmProductUnit;
        this.init(repoUrl, repoModel);
    }
}